import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServiceSection from './components/ServiceSection';
import CompanySection from './components/CompanySection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-jp">
      <Navbar />
      <main>
        <HeroSection />
        <ServiceSection />
        <CompanySection />
      </main>
      <Footer />
    </div>
  );
}